import {
    Button,
    Tag,
    Flex,
    FormControl,

    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    Select,
    Box
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import SituacaoJuridicaService from "../../../main/services/SituacaoJuridicaService";
import { useHistory } from 'react-router-dom';
import SemRegistros from '../../components/SemRegistros';
import { useAuthProvider } from '../../../Context/AuthProvider';
import { situacaoJuridica as situacaoJuridicaFunc } from '../../../helpers/Funcionalidades'
import { Group } from '../Criancas/Group';


const EditarSituacaoJuridica = (props) => {

    document.title = 'MCA - Situação Jurídica - Editar'
    let history = useHistory()

    const { roleKeycloack } = useAuthProvider();
    const _IsMounted = useRef(false);
    const [situacaoJuridica, setSituacaoJuridica] = useState([])
    //const [isUpdating, setIsUpdating] = useState(props.match.params.editar ? true : false)
    const [descricaoCount, setDescricaoCount] = useState(0);

    useEffect(() => {

        _IsMounted.current = true;
        fetchData();
        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    function fetchData() {
        SituacaoJuridicaService.getSituacaoJuridica(props.match.params.id)
            .then(res => {
                setSituacaoJuridica(res.data);
                setDescricaoCount(res.data.descricao.length);

                if (res.data.dataFim !== null) {
                    Swal.fire({
                        title: 'Erro!',
                        'text': "Você não pode alterar um registro inativo!",
                        icon: 'error',
                        confirmButtonText: 'Fechar',
                        confirmButtonColor: '#169499'
                    }).then(() => {
                        history.push("/situacao-juridica/lista")
                    })
                }

            }).catch((err) => {
                Swal.fire({
                    title: 'Atenção!',
                    'text': "Registro não encontrado",
                    icon: 'warning',
                    confirmButtonText: 'Fechar',
                    confirmButtonColor: '#169499'
                }).then(() => {
                    history.push("/situacao-juridica/lista")
                })
            })
    }

    const validate = (values) => {
        const errors = {};

        if (!values.tipo || values.tipo === "" || values.tipo.trim() === "") {
            errors.tipo = "Tipo de situação jurídica é obrigatório!";
        }

        if (!values.descricao || values.descricao === "" || values.descricao.trim() === "") {
            errors.descricao = "Descrição é obrigatória!";
        }

        return errors;
    };

    // function toggleIsEditing() {
    //     setIsUpdating(!isUpdating)
    // }

    return roleKeycloack && roleKeycloack.includes(situacaoJuridicaFunc.situacaoJuridicaEditar) ? (

        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex
                flexDir="row"
                justifyContent="space-between"
            >

                <Heading fontSize={'large'}>
                    Editar Situação Jurídica
                </Heading>
                <Button onClick={history.goBack} colorScheme={"teal"} px={16}>
                    Voltar
                </Button>
            </Flex>
            <Flex>

                <Formik
                    validate={validate}
                    validateOnChange={false}
                    validateOnBlur={false}
                    enableReinitialize
                    initialValues={{
                        descricao: situacaoJuridica.descricao || "",
                        tipo: situacaoJuridica.tipo || "",
                    }}
                    onSubmit={(values, actions) => {
                        SituacaoJuridicaService.atualizarSituacaoJuridica(situacaoJuridica.id, values)
                            .then((res) => {
                                Swal.fire({
                                    title: 'Sucesso!',
                                    'text': 'Registro atualizado com sucesso!',
                                    icon: 'success',
                                    confirmButtonText: 'Continuar',
                                    confirmButtonColor: '#169499'
                                }).then(function () {
                                    actions.setSubmitting(false);
                                    history.push("/situacao-juridica/" + res.data.id);

                                });
                                actions.setSubmitting(false);
                                //setIsUpdating(false)
                            }).catch((error) => {
                                actions.setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                                actions.setSubmitting(false);
                            })
                    }}>
                    {(props) => (
                        <Flex
                            flexDir="column"
                            mt="40px"
                            w="100%">
                            <Form>
                                <Flex flexDir="column">
                                    <Group bgColor="#fff" title="" py="12px" >
                                        <Box width={{ lg: '50%' }}>
                                            <Field name="tipo">
                                                {({ field, form }) => (
                                                    <Flex flexDir="column">
                                                        <FormControl isInvalid={form.errors.tipo && form.touched.tipo}>
                                                            <FormLabel htmlFor="descricao">Tipo de Situação Jurídica*</FormLabel>
                                                            <Select
                                                                backgroundColor={"white"}
                                                                id="tipo"
                                                                {...field}
                                                                placeholder="Selecione o Tipo de Situação Jurídica"
                                                                h="42px"
                                                            >
                                                                <option value={"P"}>Processo</option>
                                                                <option value={"D"}>Procedimento</option>
                                                            </Select>
                                                            <FormErrorMessage>{form.errors.tipo}</FormErrorMessage>
                                                        </FormControl>
                                                    </Flex>
                                                )}
                                            </Field>
                                            <Field name="descricao">
                                                {({ field, form }) => (
                                                    <Flex flexDir="column" mt={5}>
                                                        <FormControl
                                                            isInvalid={form.errors.descricao && form.touched.descricao}>
                                                            <FormLabel htmlFor="descricao">Descrição*</FormLabel>
                                                            <Input
                                                                autoFocus
                                                                backgroundColor={"white"}
                                                                id="descricao"
                                                                {...field}
                                                                placeholder="Informe a Descrição da Situação Jurídica"
                                                                maxLength={255}
                                                                onChange={(e) => {
                                                                    setDescricaoCount(e.target.value.length);
                                                                    form.setFieldValue(field.name, e.target.value);
                                                                }}
                                                                h="42px"
                                                            />
                                                            <FormErrorMessage>{form.errors.descricao}</FormErrorMessage>
                                                        </FormControl>
                                                    </Flex>
                                                )}
                                            </Field>
                                            <Flex flexDirection="row-reverse">
                                                <Tag maxW="max-content">{`${descricaoCount}/255`}</Tag>
                                            </Flex>
                                        </Box>
                                    </Group>
                                    <Flex mt={2} justifyContent="space-between">
                                        <Flex></Flex>
                                        <Flex flexDir={["column", "row"]}>
                                            <Button
                                                mt={4}
                                                mr={2}
                                                colorScheme="teal"
                                                px={14}
                                                isLoading={props.isSubmitting}
                                                type="submit"
                                                translate="no">
                                                Salvar
                                            </Button>
                                        </Flex>
                                    </Flex>

                                </Flex>
                            </Form>

                        </Flex>
                    )}
                </Formik>
            </Flex>
        </Flex>


    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    );
}
export default EditarSituacaoJuridica;